import styled from 'styled-components';

export const LkNavbarContainer = styled.div`
  width: 100%;

  display: flex;
  padding: 30px 0;
  justify-content: space-between;
  align-items: center;

  a,
  .side-block {
    color: #38485bcc;
    font-size: 16px;

    &:hover {
      text-decoration: underline;
    }
  }

  .side-block {
    display: flex;
    gap: 15px;
    border: 0;
    background: none;

    color: #38485bcc;
    font-size: 16px;
  }
`;
